import styled from 'styled-components'
import { GridWrapper } from './ListingPreview.styles'
import { BREAKPOINT_SMALL, Button, Z_INDEX } from '@big-red-group/storefront-common-ui'
import { ListingContainer } from '../SearchTemplate.styles'
import { Wrapper as SelectWrapper } from '@/components/Select.styles'

export const NoResultsWrapper = styled.div`
  text-align: center;
  padding: 30px;
  width: 100%;
  border-radius: 15px;
  margin-top: 25px;
  border: 1px solid var(--black);
  font-size: 17px;
  box-sizing: border-box;
`

export const GridLeft = styled.div<{ topBarHeight: number }>`
  width: 250px;
  flex-shrink: 0;
  position: sticky;
  top: 110px;
  left: 0px;
  z-index: 0;
  max-height: 100%;
  overflow: hidden;
  opacity: 0;
  transition: 0.1s ease-in-out;

  @media (max-width: 1200px) {
    width: 200px;
  }

  @media (max-width: 768px) {
    position: fixed;
    max-height: unset;
    overflow: unset;
    top: 100%;
    z-index: ${Z_INDEX.high};
    left: 0;
    width: 100%;
    height: calc(100vh - ${({ topBarHeight }) => topBarHeight + 30}px);
    background: white;
    border-radius: 0;
    border: 0;
    box-sizing: border-box;
    opacity: 1;
    transition: 0.35s ease-in-out;
  }
`
export const GridRight = styled.div`
  width: 100%;
  z-index: 2;
  background: white;
  position: absolute;
  right: 0;
  transition: 0.3s ease-in-out;

  @media (max-width: 768px) {
    position: static;
    margin-top: 20px;
  }
`

export const ProductsHeadingWrapper = styled.div`
  margin-bottom: 16px;

  @media (max-width: ${BREAKPOINT_SMALL}px) {
    margin-bottom: 4px;
  }
`

export const StickyFiltersWrapper = styled.div<{ isSticky: boolean; topBarHeight: number }>`
  @media (max-width: ${BREAKPOINT_SMALL}px) {
    box-shadow: ${({ isSticky }) => (isSticky ? '0 4px 8px rgba(0, 0, 0, 0.08)' : 'none')};
    position: sticky;
    top: ${({ topBarHeight }) => `${topBarHeight}px`};
    width: 100vw;
    padding: 16px 0 0;
    margin-left: -25px;
    z-index: ${Z_INDEX.medium + 1};
    background: white;
    right: 0;
    box-sizing: border-box;
    contain: layout paint; /* Optimization: Stops unnecessary browser repaints / flickers */
  }
`

export const FilterTriggerBar = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  gap: 7px;
  transition: transform 0.3s ease-in-out;

  @media (max-width: ${BREAKPOINT_SMALL}px) {
    .total-count {
      display: none;
    }
  }

  ${SelectWrapper} {
    margin-left: auto;
    flex-shrink: 0;

    select {
      padding: 12px 16px;
      width: 200px;
      font-size: 14px;
      line-height: 18px;
      font-family: var(--font-regular);
      color: unset;
      text-align: inherit;
      position: relative;
    }
  }

  @media (max-width: ${BREAKPOINT_SMALL}px) {
    overflow-x: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    flex-wrap: nowrap;
    white-space: nowrap;
    padding-left: 20px;
    padding-right: 20px;
    width: 100%;
    margin-left: 0;
    box-sizing: border-box;
    overscroll-behavior-x: none;
    &::-webkit-scrollbar {
      display: none;
    }

    ${SelectWrapper} {
      display: none;
    }
  }
`

export const ResultsCountWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
  gap: 8px;

  .total-count {
    display: none;
  }

  @media (max-width: ${BREAKPOINT_SMALL}px) {
    .total-count {
      display: block;
    }
  }

  .sort-icon {
    display: none;
    gap: 8px;
    position: relative;
    align-items: center;

    & > svg {
      width: 16px;
      flex-shrink: 0;
    }
    ${SelectWrapper} {
      opacity: 0;
      position: absolute;
      width: 100%;
      > select {
        padding: 0;
      }
    }
  }

  @media (max-width: 768px) {
    margin: 0%;
    padding: 16px 20px;
    .sort-icon {
      display: flex;
    }
  }

  @media (max-width: 400px) {
    .showing-text {
      display: none;
    }
    .sort-label {
      font-size: 14px;
    }
  }
`

export const Close = styled.div`
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  svg {
    width: 18px;
    height: 18px;
  }
`
export const FilterDropdownWrap = styled.div<{ hideInDesktop?: boolean }>`
  position: relative;
  flex-shrink: 0;

  @media (min-width: ${BREAKPOINT_SMALL + 1}px) {
    ${({ hideInDesktop }) =>
      hideInDesktop &&
      `
      display: none;
  `}
`
export const FilterDropdownButton = styled(Button)<{ filterOpen: boolean; hideInDesktop?: boolean }>`
  position: relative;
  text-transform: capitalize;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  height: 44px;
  padding: 0 16px !important;
  border-color: #ededed !important;
  border-radius: 8px !important;
  font-size: 14px !important;

  @media (min-width: ${BREAKPOINT_SMALL + 1}px) {
    ${({ hideInDesktop }) =>
      hideInDesktop &&
      `
      display: none;
  `}
  }

  ${({ filterOpen }) =>
    !filterOpen &&
    `
    &:hover {
      border-color: var(--black) !important;
      background: white !important;
    }
  `}

  svg {
    width: 11px;
    height: 11px;
  }

  &.all-filters {
    svg {
      width: 20px;
      height: 20px;
    }
  }
  &:not(.all-filters) {
    min-width: 150px;
    box-sizing: border-box;

    &:after {
      content: '';
      display: block;
      width: 7px;
      height: 7px;
      border-right: 1px solid currentColor;
      border-bottom: 1px solid currentColor;
      transform: rotate(45deg);
      position: relative;
      top: -2px;
      transition: transform 0.25s ease-in-out;
      flex-shrink: 0;
    }
  }

  ${({ filterOpen }) =>
    filterOpen &&
    `
    &:not(.all-filters)::after {
      transform: rotate(-135deg);
      top: 2px;
    }
  `}

  @media (max-width: 768px) {
    &:not(.all-filters) {
      min-width: unset;
      gap: 20px;
      font-size: 14px;
      height: 40px;
    }

    &.all-filters {
      flex-shrink: 0;
      font-size: 0;
      gap: 0;
      height: 40px;
      padding: 0 !important;
      width: 50px;
      display: flex;
      justify-content: center;

      svg {
        width: 25px;
        height: 25px;
      }
      span {
        display: none;
      }
    }
  }
`
export const FilterDropdownButtonLabel = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-shrink: 0;
`
export const FilterIndicator = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  color: var(--black);
  border-radius: 50%;
  margin-left: 7px;
  font-size: 13px;
  font-weight: var(--font-bold);
`
export const FilterDropdownPanel = styled.div<{ active: boolean }>`
  padding: 15px;
  background: white;
  position: absolute;
  top: calc(100% + 10px);
  z-index: 3;
  border-radius: 4px;
  width: 240px;
  display: grid;
  grid-template-columns: 1fr;
  gap: 15px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  display: none;
  max-height: 400px;
  overflow: auto;

  ${({ active }) =>
    active &&
    `
    display: block;
  `}

  @media (max-width: 768px) {
    display: block;
    position: fixed;
    top: 100%;
    left: 0;
    z-index: ${Z_INDEX.high};
    padding: 0;
    width: 100%;
    height: 50%;
    max-height: unset;
    box-sizing: border-box;
    border-radius: 0;
    box-shadow: none;
    overflow: unset;
    padding-bottom: 70px;
    transition: top 0.35s ease-in-out;
    pointer-events: none;

    ${({ active }) =>
      active &&
      `
      top: 50%;
      pointer-events: all;
    `}
  }
`

export const ClearButton = styled.div`
  padding: 12px;
  text-decoration: underline;
  cursor: pointer;
`

export const FilterBg = styled.div<{ active: boolean }>`
  display: none;
  position: fixed;
  left: 0;
  top: 0;
  opacity: 0;
  background: black;
  width: 100%;
  height: 100%;
  z-index: ${Z_INDEX.high - 1};
  pointer-events: none;
  transition: 0.35s ease-in-out;
  touch-action: none; /* prevent gestures */
  overscroll-behavior: contain; /* stop scroll chaining */

  @media (max-width: 768px) {
    ${({ active }) =>
      active &&
      `
      display: block;
      opacity: 0.5;
      pointer-events: all;
    `}
  }
`

export const PanelContent = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;

  @media (max-width: 768px) {
    padding: 18px;
    overflow: auto;
    flex-grow: 2;
    height: fit-content;
    max-height: calc(100% - 72px);
    box-sizing: border-box;
  }
`
export const TagFilters = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  gap: 8px;
`
export const PricingButtons = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 50%) minmax(0, 50%);
  gap: 8px;

  @media (max-width: 768px) {
    > button {
      font-size: 14px;
      padding: 10px 10px;
    }
  }
`
export const CheckboxFilters = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  width: 100%;
  gap: 16px;
`
export const GroupHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 8px;
`
export const GroupHeaderToggle = styled.div<{ active: boolean; openByDefault?: boolean }>`
  display: block;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid var(--whitesmoke);
  transition: all 0.15s ease-in-out 0s;
  cursor: pointer;

  svg {
    width: 10px;
    height: 10px;
    color: var(--black);
    transition: all 0.15s ease-in-out 0s;
  }

  &:hover {
    border-color: var(--whitesmoke);
  }

  ${({ active }) =>
    active &&
    `
    background: var(--whitesmoke);
    border-color: var(--whitesmoke);

    svg {
      transform: rotate(180deg);
    }
  `}

  ${({ openByDefault }) =>
    openByDefault &&
    `
      background: transparent;
      border-color: transparent;
      width: 24px;
      height: 24px;

      svg {
        transform: rotate(0deg);
        width: 13px;
        height: 13px;
      }
  `}
  ${({ openByDefault, active }) =>
    openByDefault &&
    !active &&
    `
      svg {
        transform: rotate(180deg);
        width: 13px;
        height: 13px;
      }
  `}
`
export const GroupSublinks = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  margin-bottom: 10px;
  padding-left: 20px;

  label {
    font-size: 14px;
  }
`

export const ListingWrap = styled(ListingContainer)<{ active: boolean; activeMinHeight: number; topBarHeight: number }>`
  position: relative;
  padding-left: 0;

  @media (min-width: ${BREAKPOINT_SMALL}px) {
    min-height: ${({ activeMinHeight }) => activeMinHeight}px;
  }

  ${({ active, topBarHeight }) =>
    active &&
    `
      ${GridLeft} {
        opacity: 1;
      }
      @media (min-width: 1201px) {
        ${GridWrapper} {
          grid-template-columns: repeat(3, 1fr);
        }
      }
      @media (min-width: 600px) {
        ${GridRight} {
          width: calc(100% - 280px);
        }
      }
      @media (max-width: 768px) {
        ${GridLeft} {
          top: 0;
        }
      }

      @media (max-width: ${BREAKPOINT_SMALL}px) {
      ${GridLeft} {
        top: ${topBarHeight + 30}px;
      }
    }
    `}
`

export const ViewMoreWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`
export const ViewMore = styled(Button)`
  min-width: 180px;

  @media (max-width: ${BREAKPOINT_SMALL}px) {
    width: 100%;
  }
`
